import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const StudyMaterialRequestCreateSlice = createSlice({
  name: "StudyMaterialRequestCreateSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    studyMaterialRequestCreate: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successStudyMaterialRequestCreate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureStudyMaterialRequestCreate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearStudyMaterialRequestCreate: (state) => {
      state.data = {};
    },
  },
});

export const {
  studyMaterialRequestCreate,
  successStudyMaterialRequestCreate,
  failureStudyMaterialRequestCreate,
  clearStudyMaterialRequestCreate,
} = StudyMaterialRequestCreateSlice.actions;

export default StudyMaterialRequestCreateSlice.reducer;
